export class WFXAndVersionsIdReqDto {
    originalId: number;
    versionsId: number;
    constructor(
        originalId: number,
        versionsId: number,
    ) {
        this.originalId = originalId;
        this.versionsId = versionsId;
    }
}